module.exports = __webpack_public_path__ + "img/person_facepalming.97b99b4c.gif";